import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './Breadcrumbs.css';
import React from 'react';
import { withRouter } from 'react-router-dom';
import HeaderModuleWrapper from './HeaderModuleWrapper';
import IconChevronRight from '../atoms/Icons/IconChevronRight';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import { tealiumClickFunc } from '../../utils/tealium';
import { getLatestUserCookie } from '../Login/user_session';
import { get } from '../../utils';
import { fetchData } from '../../utils/fetchData';
var Breadcrumbs = function Breadcrumbs(_ref) {
  var mobileLabel = _ref.mobileLabel,
    location = _ref.location,
    breadcrumbAnalytics = _ref.breadcrumbAnalytics;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var currentLocation = location && location.pathname ? location.pathname : undefined;
  var breadcrumb = sitecoreContext.breadcrumb;
  var _React$useState = React.useState({
      firstName: '',
      lastName: ''
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    userProfile = _React$useState2[0],
    setUserProfile = _React$useState2[1];
  React.useEffect(function () {
    if (!breadcrumb || breadcrumb.length <= 1) {
      return;
    }
    getLatestUserCookie().then(function (userCookie) {
      if (userCookie.login_status && !userCookie.error) {
        var apiGlobal = get(sitecoreContext, 'configuration.globalApi.apiGlobal') || 'https://replaceGlobal';
        fetchData({
          path: "".concat(apiGlobal, "/graphql/user"),
          options: {
            method: 'POST',
            body: JSON.stringify({
              query: "{ userProfile { firstName, lastName } }"
            })
          },
          authToken: userCookie.access_token
        }).then(function (data) {
          var _data$data$userProfil = data.data.userProfile,
            firstName = _data$data$userProfil.firstName,
            lastName = _data$data$userProfil.lastName;
          setUserProfile({
            firstName: firstName,
            lastName: lastName
          });
        });
      }
    });
  }, []);
  if (!breadcrumb || breadcrumb.length <= 1) {
    return null;
  }
  var previousLevelPage = breadcrumb.length >= 2 ? breadcrumb[breadcrumb.length - 2] : undefined;
  var previousLevelUrl = previousLevelPage && previousLevelPage.url ? previousLevelPage.url : '/';
  var previousLevelLabel = previousLevelPage && previousLevelPage.label ? previousLevelPage.label : mobileLabel;
  var breadcrumbCssClass = 'breadcrumb-nav';
  var replacePlaceholders = function replacePlaceholders(label) {
    if (label.indexOf('#username#') > -1) {
      var firstName = userProfile.firstName,
        lastName = userProfile.lastName;
      return label.replace('#username#', "".concat(firstName, " ").concat(lastName));
    }
    return label;
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    className: breadcrumbCssClass
  }, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: "\n        {\n          \"@context\": \"https://schema.org\",\n          \"@type\": \"BreadcrumbList\",\n          \"itemListElement\": [\n            ".concat(breadcrumb.map(function (b, index) {
        return "{\n                  \"@type\": \"ListItem\",\n                  \"position\": ".concat(index + 1, ",\n                  \"name\": \"").concat(b.label && b.label.replace(/"/g, "'"), "\",\n                  \"item\": \"").concat(sitecoreContext && sitecoreContext.origin).concat(b.url, "\"\n                }");
      }), "\n          ]\n        }")
    }
  }), /*#__PURE__*/React.createElement("ul", {
    className: "breadcrumb"
  }, breadcrumb.map(function (b, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index,
      className: "breadcrumb__list"
    }, currentLocation && b.url.toLowerCase() === currentLocation.toLowerCase() ? /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: replacePlaceholders(b.label)
      }
    }) : /*#__PURE__*/React.createElement("a", {
      href: b.url,
      title: b.label,
      className: "link",
      "aria-label": "breadcrumb link",
      "aria-labelledby": "breadcrumb link",
      onClick: function onClick() {
        tealiumClickFunc(breadcrumbAnalytics, b.enLabel);
      }
    }, /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: b.label
      }
    })), index < breadcrumb.length - 1 && /*#__PURE__*/React.createElement(IconChevronRight, {
      className: "breadcrumb__list-icon"
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: "breadcrumb__back"
  }, /*#__PURE__*/React.createElement("a", {
    className: "breadcrumb__back-link",
    href: previousLevelUrl,
    "aria-label": "Previous Level",
    "aria-labelledby": "Previous Level"
  }, /*#__PURE__*/React.createElement(IconChevronRight, null), /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: previousLevelLabel
    }
  }))));
};
export default withRouter(Breadcrumbs);
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    className = _ref2.className;
  return /*#__PURE__*/React.createElement(HeaderModuleWrapper, {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className)
  }, children);
};
var commonStyles = "cuqupq4";
var ltrStyles = "l1o46kfz";
var rtlStyles = "roq3hbm";